import React from 'react';
import PropTypes from 'prop-types';
import Button from 'material-ui/Button';
import ActionFavorite from 'material-ui-icons/Favorite';
import * as Colors from 'material-ui/colors';
import Spinner from 'react-loader';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

class LoaderButton extends React.Component {
  static propTypes = {
    icon: PropTypes.any,
    loading: PropTypes.bool,
    spinConfig: PropTypes.object,
    spinColorDark: PropTypes.string,
    spinColorLight: PropTypes.string,
    spinColorDisabled: PropTypes.string,
    children: PropTypes.node,
    onClick: PropTypes.func.isRequired,
    style: PropTypes.object
  };

  static defaultProps = {
    icon: ActionFavorite,
    loading: false,
    spinConfig: {
      lines: 10,
      length: 4,
      width: 2,
      radius: 3,
    },
    spinColorDark: Colors.darkBlack,
    spinColorLight: Colors.white,
    spinColorDisabled: Colors.minBlack,
    children: <span>Submit</span>,
    style: {}
  };

  handleClick (ev) {
    ev.preventDefault();
    this.props.onClick(ev);
  }

  getColor () {
    if (this.props.disabled) {
      return this.props.spinColorDisabled;
    } else if (this.props.primary || this.props.secondary) {
      return this.props.spinColorLight;
    } else {
      return this.props.spinColorDark;
    }
  }

  renderIcon () {
    let icon,
        color = this.getColor();

    if (this.props.loading) {
      icon = (
        <div style={{position: 'absolute', top: 18, left: 20}}>
          <Spinner
            ref='spinner'
            {...this.props.spinConfig}
            color={color}
            loaded={false}
          />
        </div>
      );
    } else {
      if (typeof(this.props.icon) === 'object') {
        icon = this.props.icon;
      } else {
        icon = <this.props.icon color={color} style={{width: 20, height: 20}} />;
      }
    }

    return (
      <div style={{
        width: 20,
        height: 20,
        marginRight: 5
      }}>
        {icon}
      </div>
    );
  }

  render () {
    let color = this.getColor();

    const props = {
      children: this.props.children,
      className: this.props.className,
      disabled: this.props.disabled || this.props.loading,
      href: this.props.href,
      label: this.props.label || <span style={{paddingLeft: 15, color}}>{this.props.children}</span>,
      color: this.props.labelColor || color,
      style: this.props.style,
      type: this.props.type,
      raised: this.props.raised
    };

   return (
      <MuiThemeProvider>
        <Button
          {...props}
          onClick={this.handleClick.bind(this)}>
          {this.renderIcon()}
          {this.props.children}
        </Button>
      </MuiThemeProvider>
    );
  }
}

export default LoaderButton;



// WEBPACK FOOTER //
// ./src/components/LoaderButton/index.js